import { render, staticRenderFns } from "./share2-icon.vue?vue&type=template&id=28d6c5c9"
import script from "./share2-icon.vue?vue&type=script&lang=js"
export * from "./share2-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports